import styled from "styled-components";

export type InsetSquishProps = {
  scale?: "tiny" | "small" | "medium" | "big" | "huge";
};

export const InsetSquish = styled.div<InsetSquishProps>`
  padding: ${(props) =>
      props.theme.insetSquish.spacings[props.scale || "small"]}px
    ${(props) =>
      props.theme.insetSquish.spacings[props.scale || "small"] *
      props.theme.insetSquish.squishRatio}px;
`;

export default InsetSquish;
